module.exports = __webpack_public_path__ + "img/CPG_Recall_3_Set.253ef2da.png";